import React, { useContext, useEffect, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import urlWithAuthParams from "enterprise-integrations/helpers/urlWithAuthParams";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a, _b, _c, _d;
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { clientSecret } = formData;
  const subscriptions = [
    { label: "Enterprise and GCC government plans", value: "ENTERPRISE" },
    { label: "GCC High government plan", value: "GCC_HIGH" },
    { label: "DoD government plan", value: "DOD" }
  ];
  const [O365ContentTypesStatus, setO365ContentTypes] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      o365_tenant_id: ((_a = formData == null ? void 0 : formData.tenantId) == null ? void 0 : _a.value) || "",
      o365_client_id: ((_b = formData == null ? void 0 : formData.clientId) == null ? void 0 : _b.value) || "",
      o365_client_secret: ((_c = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _c.value) || "",
      o365_endpoint: ((_d = formData == null ? void 0 : formData.subscriptionType) == null ? void 0 : _d.value) || ""
    },
    urlWithAuthParams
  );
  useEffect(() => {
    setO365ContentTypes(null);
    if (O365ContentTypesStatus.error) {
      setFormError({
        full_message: O365ContentTypesStatus.error,
        nice_message: "Unable to connect to Office 365 using provided configuration."
      });
    }
    return () => {
      setFormError(null);
    };
  }, [O365ContentTypesStatus.error, setO365ContentTypes]);
  const handleSubmit = () => {
    setO365ContentTypes(ApiRoutes.INTEGRATIONS.O365.CONTENT_TYPES);
  };
  const isFormValid = formValidation.isFormValid(
    ["o365Name", "tenantId", "clientId", "clientSecret", "subscriptionType"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      loading: O365ContentTypesStatus.loading,
      disabled: isFormValid,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "o365Name",
        type: "text",
        fieldData: formData.o365Name,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: clientSecret == null ? void 0 : clientSecret.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "tenantId",
        type: "text",
        fieldData: formData.tenantId,
        onChange,
        label: "Directory (tenant) ID",
        help: "The GUID of the tenant to which the content belongs.",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        help: "The GUID of your application that created the subscription.",
        label: "Application (client) ID",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: "Client Secret",
        help: "A secret string that the application uses to prove its identity when requesting a token.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        name: "subscriptionType",
        id: "subscriptionType",
        onChange,
        fieldData: formData.subscriptionType,
        help: "Office 365 subscription plan for your organization.",
        required: true,
        label: "Subscription Type"
      },
      renderOptions(subscriptions, "Choose a Subscription")
    )
  );
};
export default StepAuthorize;
